/**
 * Handles "Show more" pagination for SEO pages by revealing hidden batches
 * Renders 10 pages worth initially, shows them progressively
 */
if (!customElements.get('pages-pagination')) {
  class PagesPagination extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      this.loadMoreButton = this.querySelector('.js-pages-load-more');
      this.messageEl = this.querySelector('.js-pages-message');
      this.pagesPerBatch = parseInt(this.dataset.pagesPerBatch) || 13;
      this.totalPages = parseInt(this.dataset.totalPages) || 0;
      this.currentBatch = parseInt(this.dataset.currentBatch) || 1;

      this.loadMoreClickHandler = this.loadMoreClickHandler || this.handleLoadMoreClick.bind(this);

      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', this.loadMoreClickHandler);
      }
    }

    destroy() {
      if (this.loadMoreButton) {
        this.loadMoreButton.removeEventListener('click', this.loadMoreClickHandler);
      }
      this.loadMoreClickHandler = null;
    }

    handleLoadMoreClick(evt) {
      evt.preventDefault();
      this.showNextBatch();
    }

    showNextBatch() {
      this.currentBatch++;
      this.dataset.currentBatch = this.currentBatch;

      // Show all items up to current batch
      const allItems = this.querySelectorAll('.js-pages-result');
      allItems.forEach((item) => {
        const itemBatch = parseInt(item.dataset.batch);
        if (itemBatch <= this.currentBatch) {
          item.style.display = '';
        }
      });

      // Update visible count
      const visibleCount = Math.min(this.currentBatch * this.pagesPerBatch, this.totalPages);
      this.updateMessage(visibleCount);
      this.updateProgressBar(visibleCount);

      // Hide entire pagination container if we've shown everything
      if (visibleCount >= this.totalPages) {
        const paginationContainer = this.querySelector('.js-pages-pagination');
        if (paginationContainer) {
          paginationContainer.classList.add('hidden');
        }
        // Also hide the divider line
        this.querySelectorAll('.js-pages-paginated-only').forEach((elem) => elem.remove());
      }

      // Re-sort after showing new items
      if (window.sortSEOPages) {
        window.sortSEOPages();
      }
    }

    updateMessage(visibleCount) {
      if (this.messageEl) {
        // Parse the current message to maintain translation
        const template = this.messageEl.textContent;
        // Replace numbers in the format "X of Y" or similar
        const updated = template.replace(/\d+/, visibleCount);
        this.messageEl.textContent = updated;
      }
    }

    updateProgressBar(visibleCount) {
      const progressBar = this.querySelector('.js-pages-bar');
      if (progressBar && this.totalPages > 0) {
        const percent = (visibleCount / this.totalPages * 100).toFixed(1);
        progressBar.style.setProperty('--pagination-percent', `${percent}%`);
      }
    }
  }

  customElements.define('pages-pagination', PagesPagination);
}